import { DatePipe } from "@angular/common";
import { HttpErrorResponse } from "@angular/common/http";
import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { IMyDateModel, IMyDpOptions, IMyInputFieldChanged } from "mydatepicker";
import { ToastrService } from "ngx-toastr";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { GlobalComponent } from "src/app/global/global.component";
import { claiminput } from "../../timesheetverification/timesheetverification.model";
import { ClaimsListService } from "../claims-list/claims-list.service";
import {
  AmountInfo,
  ClaimServiceLine,
  ClaimServiceLineBO,
  EmitBo,
  GenderList,
  groupList,
  MarkServiceAsPaidBO,
  PaymentInfo,
  Proclaim,
  ResubmissionList,
  SpendDownBO,
  TimesheetserviceLineBO,
  ZipcodeDetail,
} from "../claims.model";
import { GridComponent, PageSettingsModel, ReorderService } from "@syncfusion/ej2-angular-grids";
import { CommonApiService } from "src/app/commonapiservice";
import { GeneralService } from "src/app/service/general.service";
import { NgbPopover } from "@ng-bootstrap/ng-bootstrap";
declare var $: any;
@Component({
  selector: "app-claims-edit",
  templateUrl: "./claims-edit.component.html",
  styleUrls: ["./claims-edit.component.scss"],
  providers:[ReorderService]
})
export class ClaimsEditComponent implements OnInit {
  private onDestroy$: Subject<void> = new Subject<void>();
  TemppClientList: any = [];
  Profession: boolean = false;
  markAsPaidForm: FormGroup;
  claimServiceLines: any[] = [];
  deletionId: number = 0;
  UserConfirmDOBDate: number = 0;
  AdmissionDatecheck: number = 0;
  ResubmissionList: ResubmissionList[];
  @Input() isInputOptions: EmitBo;
  timesheetserviceDate: any;
  @Output() isOutputOptions = new EventEmitter<EmitBo>();
  ProfessionClaimList: Proclaim;
  timesheetVerificationInput: claiminput = new claiminput();
  genderList: GenderList[];
  gender: string;
  update: boolean = false;
  totalhours: any = "";
  startserviceDate: any = "";
  ensserviceDate: any = "";
  AlterClaimsStatus:any=[];
  openverification: boolean = false;
  Markaspaidlist: PaymentInfo = new PaymentInfo();
  MarkasPartialpaidlist: PaymentInfo = new PaymentInfo();
  spendDownDetails: SpendDownBO = new SpendDownBO();
  timesheetserviceLine: TimesheetserviceLineBO = new TimesheetserviceLineBO();
  showEditorView: boolean = false;
  markAsPaidPartialForm: FormGroup;
  SpendDownForm: FormGroup;
  timesheetdateList: any[] = [];
  timesheetIdlist: any[] = [];
  getReportTypeList:any;
  public myDatePickerOptions: IMyDpOptions = {
    dateFormat: "mm/dd/yyyy",
    showClearDateBtn: false,
    editableDateField: true,
  };
  isManuallyPost: boolean = null;
  public myDatePickerOptionsheader: IMyDpOptions = {
    dateFormat: "mm/dd/yyyy",
    disableSince: {
      year: new Date().getFullYear(),
      month: new Date().getMonth() + 1,
      day: new Date().getDate() + 1,
    },
    showClearDateBtn: false,
    editableDateField: true,
  };
  MarkServiceAsPaid: MarkServiceAsPaidBO = new MarkServiceAsPaidBO()
  @ViewChild('gridHistory') public gridHistory: GridComponent;
  @ViewChild('gridservicLine') public gridservicLine: GridComponent;

  claimHistoryData: any = [];
  pageSettings: PageSettingsModel;
  gridDateFormat: object;
  formatOptions:object;
  View835Claim: any;
  companydetails: any;
  payorDetail: any;
  paymentDetail: any;
  patientClaimDetails: any;
  TotalUnits: any = 0;
  viewClaimPdfError: any = ""
  isEemptyImportClaim: boolean;
  @ViewChild('pdflist') pdflist;
  isViewAppealRequestForm:boolean=false;
  isViewUACCoverLetter:boolean=false;
  claimAttachmentIds:any=[];
  reportTransmissionList:any;
  reportTypeDeopdownList:any;
  getTXNList:any;
  constructor(
    public Claimslistservice: ClaimsListService,
    public toastrService: ToastrService,
    private ref: ChangeDetectorRef,
    public global: GlobalComponent,
    private datePipe: DatePipe,
    public CommonAPI: CommonApiService,
    private formBuilder: FormBuilder,
    public general: GeneralService,
    private cdr: ChangeDetectorRef
  ) {
    this.markAsPaidForm = this.formBuilder.group({
      mapaiddate: ["", Validators.required],
      mapaidAmount: [""],
      typeofpay: ["", Validators.required],
    });
    this.markAsPaidPartialForm = this.formBuilder.group({
      mapaidAmount: ["", Validators.required],
      mapaiddate: ["", Validators.required],
    });
    this.SpendDownForm = this.formBuilder.group({
      spendPaidDate: ["", Validators.required],
      spendpaidAmount: ["", Validators.required],
    });
  }

  
  @ViewChild('popover', { static: false }) popover: NgbPopover | undefined;
  ngOnInit(): void {
    if (this.isInputOptions.claimMasterId != "00000000-0000-0000-0000-000000000000") {
      this.getResubmissionCode();
      this.getClaimStatusCode();
      this.EnableProfesionClaim();
      this.getGender();
    } else {
      this.BacktoClaimsList();
    }
    this.pageSettings = { pageSize: 6 };
    this.gridDateFormat = { type: "date", format: "MM/dd/yyyy h:mm:ss a" };
    this.getStatusLovTXN();
    this.getReportTypeDeopdownList();
    this.getReportTransmissionList();
    this.formatOptions = { type: "date", format: "MM/dd/yyyy" };

  }
  ngAfterContentChecked() {
    this.cdr.detectChanges();
  }
  //...............................................getResubmissionCode.................................................
  getResubmissionCode() {
    let url = "api/LOV/getLovDropDown?"
    let params = new URLSearchParams();
    params.append("ListCode", 'RESUBMISSION');
    this.CommonAPI.getDropDownList("RESUBMISSION",params, url, "LovDropDown").then(
      (data: ResubmissionList[]) => {
        this.ResubmissionList = data;
      },
      (err) => { }
    );
  }
  //...............................................getClaimStatusCode.................................................
  getClaimStatusCode() {
    let url = "api/LOV/getLovDropDown?"
    let params = new URLSearchParams();
    params.append("ListCode", 'ALTERCLAIMSTATUS');
    this.CommonAPI.getDropDownList("ALTERCLAIMSTATUS",params, url, "LovDropDown").then(
      (data: any) => {
        this.AlterClaimsStatus = data;
      },
      (err) => { }
    );
  }
  // ................................................EnableProfesionClaim..........................................
  EnableProfesionClaim() {
    this.getResubmissionCode();
    this.isInputOptions.claimMasterId =
     ( this.isInputOptions.claimMasterId != undefined &&
        this.isInputOptions.claimMasterId != null && this.isInputOptions.claimMasterId  !="00000000-0000-0000-0000-000000000000")
        ? this.isInputOptions.claimMasterId
        :"00000000-0000-0000-0000-000000000000";
    let params = new URLSearchParams();
    params.append(
      "ClaimMasterId",
      this.isInputOptions.claimMasterId.toString()
    );
    let url = "api/ClaimMaster/GetClaimViewDetail?"
    this.CommonAPI.GetFunctionwithResponseTypeJson(params,url)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (data: Proclaim) => {
          this.TemppClientList = JSON.parse(JSON.stringify(data));
          this.ProfessionClaimList = data;

          this.ProfessionClaimList.subscriberPhone = (this.ProfessionClaimList.subscriberPhone) ? this.general.converPhoneGoogleLib(this.ProfessionClaimList.subscriberPhone) : null;

          this.ProfessionClaimList.subscriberAddressLine2 =
            data.client_Apt != null &&
              data.client_Apt != undefined &&
              data.client_Apt != ""
              ? "Apt" + " " + data.client_Apt
              : "";

          if (this.isInputOptions.tabsChanges != "ReadyClaims") {
            this.showEditorView = true;
          } else if (this.isInputOptions.tabsChanges == "ReadyClaims") {
            this.showEditorView = false;
          }
          this.Profession = true;
          if (this.ProfessionClaimList.serviceDetailsList.length > 0) {
            this.startserviceDate = this.datePipe.transform(
              this.ProfessionClaimList.serviceDetailsList[0].fromDate,
              "MM/dd/yyyy"
            );
            this.ensserviceDate = this.datePipe.transform(
              this.ProfessionClaimList.serviceDetailsList[
                this.ProfessionClaimList.serviceDetailsList.length - 1
              ].fromDate,
              "MM/dd/yyyy"
            );
          }

          this.ProfessionClaimList.admissionDate =
            this.ProfessionClaimList.admissionDate != null
              ? this.datePipe.transform(
                this.ProfessionClaimList.admissionDate,
                "MM/dd/yyyy"
              )
              : null;
          this.ProfessionClaimList.subscriberDOB =
            this.ProfessionClaimList.subscriberDOB != null
              ? this.datePipe.transform(
                this.ProfessionClaimList.subscriberDOB,
                "MM/dd/yyyy"
              )
              : null;
          this.ProfessionClaimList.controlNumber= (this.ProfessionClaimList.controlNumber != null && this.ProfessionClaimList.controlNumber !=undefined && this.ProfessionClaimList.controlNumber !='') ? "PWK"+this.ProfessionClaimList.controlNumber:null;
        },
       
      );
  }
  //............................EditPaidAmount...............................................................
  editPaidAmount() {
    let claimServiceLines: any[] = [];

    this.ProfessionClaimList.serviceDetailsList.forEach((element) => {
      let claimServiceLine: ClaimServiceLineBO = new ClaimServiceLineBO();
      claimServiceLine.id = element.id;
      claimServiceLine.payerPaid = element.payerPaid;
      claimServiceLine.paidDate = element.paidDate;
      claimServiceLine.paidDateFormated = this.datePipe.transform(
        claimServiceLine.paidDate,
        "MM/dd/yyyy"
      );
      claimServiceLine.fromDate = element.fromDate;
      claimServiceLine.code = element.code;
      claimServiceLine.modifier1 = element.modifier1;
      claimServiceLine.modifier2 = element.modifier2;
      claimServiceLine.modifier3 = element.modifier3;
      claimServiceLine.modifier4 = element.modifier4;
      claimServiceLine.totalUnits = element.totalUnits;
      claimServiceLine.grossCharges = element.grossCharges;
      claimServiceLine.netCharges = element.netCharges;
      claimServiceLine.actualGrossCharges = element.actualGrossCharges;
      claimServiceLine.actualNetCharges = element.actualNetCharges;
      claimServiceLine.spendownCharge = element.spendDownCharges;
      claimServiceLine.overBilledAmount=(element.actualNetCharges!=null&&element.actualNetCharges!=undefined&&element.actualNetCharges!=0&&
        element.payerPaid!=null&&element.payerPaid!=undefined&&element.payerPaid!=0)?(element.actualNetCharges-element.payerPaid):element.overBilled;
      claimServiceLine.overBilledAmount=(claimServiceLine.overBilledAmount!=null&& claimServiceLine.overBilledAmount!=undefined )? parseFloat(claimServiceLine.overBilledAmount.toFixed(2)): claimServiceLine.overBilledAmount;
      claimServiceLines.push(claimServiceLine);
    });
    this.claimServiceLines = claimServiceLines;
  }
  //.........................................................Addtimesheetdata...............................
  addtimesheetdata() {
    if (this.ProfessionClaimList.serviceDetailsList.length <= 16) {
      if (this.timesheetIdlist.length == 0) {
        this.timesheetIdlist = this.ProfessionClaimList.timesheetIdandDates.map(
          (t) => t.timesheetId
        );
      }
      if (this.timesheetdateList.length == 0) {
        this.timesheetdateList =
          this.ProfessionClaimList.timesheetIdandDates.map(
            (d) => d.timesheetDate
          );
      }
      this.timesheetserviceLine.serviceDate = "";
      this.timesheetserviceDate = "";
      this.totalhours = "";
      this.timesheetserviceLine.claimmasterId =
        this.ProfessionClaimList.masterClaimId;
        console.log(this.ProfessionClaimList,"this.ProfessionClaimList.serviceDetailsList[0].groupPayorServiceId");
        
      this.timesheetserviceLine.grouppayorserviceId =
        this.ProfessionClaimList.serviceDetailsList[0].groupPayorServiceId;
    } else {
    }
  }

  

  spenDownPaidHistory=[];
  spendownhistorycount: number;
  
  totalSpendDownPaidAmount:number=null;
  //................................................ editSpendDown................................................
  editSpendDown(spendDownId,type:string) {
    let params = new URLSearchParams();
    params.append("invoiceDetailId", spendDownId);
    let url = "api/ClaimMaster/GetInvoiceDetail?";
    this.CommonAPI.GetFunctionwithResponseTypeJson(params, url)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (data: any) => {
          this.spendDownDetails = data;
          this.spendDownDetails.formatedPaidDate = this.datePipe.transform(
            this.spendDownDetails.paidDate,
            "MM/dd/yyyy"
          );
          this.spenDownPaidHistory = data.spendDownPaidHistories;
          this.spendownhistorycount = data.spendDownPaidHistories?.length
          this.totalSpendDownPaidAmount = this.spenDownPaidHistory?.reduce((a,b) => a + b.paidAmount,0);
          console.log(this.spenDownPaidHistory);
          this.spendDownDetails.paidAmount=null;
          console.log(this.spenDownPaidHistory ,"===============this.spenDownPaidHistory");

          if(type!='delete'){
            document.getElementById("openSpendDownDetails").click();
          }
        },
        (err: any) => {
          this.toastrService.error(err, "Error");
        }
      );
  }

  
  ///////////////// Delete Spendown History/////////////////////////
  deleteSpendownHistory(ele) {
    let params = new URLSearchParams();
    params.append("Id", ele.id?.toString());
    let url = "api/ClaimMaster/DeleteSpendDownPaidHistory?";
    this.CommonAPI.DeleteFunctionForDeleteHttp(params, url)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (data: any) => {
          this.toastrService.success("SpendDown history deleted successfully!");
            setTimeout(() => {
              this.toastrService.clear();
            }, 1000);
              this.EnableProfesionClaim();
              this.editSpendDown(this.spendDownDetails.id,'delete')    
        },
        (err: HttpErrorResponse) => {
          this.toastrService.error(err.error, "Error");
          setTimeout(() => {
            this.toastrService.clear();
          }, 8000);
        }
      );
  }
  //............................UpdateSpendDown............................................................
  UpdateSpendDown() {
    this.spendDownDetails.paidDate = this.global.getDateTimeString(
      this.spendDownDetails.formatedPaidDate
    );
    let url = "api/ClaimProcess/updateSpendDown";
    this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(this.spendDownDetails, url)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (data) => {
          this.toastrService.success("SpendDown updated successfully!");
          setTimeout(() => {
            this.toastrService.clear();
          }, 5000);
          let params = new URLSearchParams();
          params.append(
            "ClaimMasterId",
            this.isInputOptions.claimMasterId.toString()
          );
          let urlLD = "api/ClaimMaster/getServiceLineDetails?";
          this.CommonAPI.GetFunctionwithResponseTypeJson(params, urlLD)
            .pipe(takeUntil(this.onDestroy$))
            .subscribe((data: ClaimServiceLine[]) => {
              this.ProfessionClaimList.serviceDetailsList = data;
            });
          let param = new URLSearchParams();
          param.append(
            "ClaimMasterId",
            this.isInputOptions.claimMasterId.toString()
          );
          let urlAD = "api/ClaimMaster/GetClaimAmount?";
          this.CommonAPI.GetFunctionwithResponseTypeJson(param, urlAD)
            .pipe(takeUntil(this.onDestroy$))
            .subscribe((data: AmountInfo) => {
              this.ProfessionClaimList.totalcharges = data.claimTotalcharges;
              this.ProfessionClaimList.amountPaid = data.claimPaidAmount;
              this.ProfessionClaimList.balanceDue =
                this.ProfessionClaimList.totalcharges -
                this.ProfessionClaimList.amountPaid;
            });
          document.getElementById("openSpendDownDetails").click();
        },
        (err: any) => {
          this.toastrService.error(err, "Error");
        }
      );
  }
  //..................................DeleteServiceLine.........................................................
  deleteServiceLine(data) {
    this.deletionId = data.id;
  }
  // ................................................deleteServiceLineConfirm................................................
  deleteServiceLineConfirm() {
    let param = new URLSearchParams();
    param.append("Id", this.deletionId.toString());
    let url = "api/ClaimMaster/DeleteServineLine?"
    this.CommonAPI.DeleteFunctionForDeleteHttp(param, url)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (data: any) => {
          this.deletionId = 0;
          this.toastrService.success("Service line deleted successfully!");
          setTimeout(() => {
            this.toastrService.clear();
          }, 8000);
          document.getElementById("openModal4").click();
          let params = new URLSearchParams();
          params.append(
            "ClaimMasterId",
            this.isInputOptions.claimMasterId.toString()
          );
          let urlLD = "api/ClaimMaster/getServiceLineDetails?";
          this.CommonAPI.GetFunctionwithResponseTypeJson(params, urlLD)
            .pipe(takeUntil(this.onDestroy$))
            .subscribe((data: ClaimServiceLine[]) => {
              this.ProfessionClaimList.serviceDetailsList = data;
            });
          let param = new URLSearchParams();
          param.append(
            "ClaimMasterId",
            this.isInputOptions.claimMasterId.toString()
          );
          let urlAD = "api/ClaimMaster/GetClaimAmount?";
          this.CommonAPI.GetFunctionwithResponseTypeJson(param, urlAD)
            .pipe(takeUntil(this.onDestroy$))
            .subscribe((data: AmountInfo) => {
              this.ProfessionClaimList.totalcharges = data.claimTotalcharges;
              this.ProfessionClaimList.amountPaid = data.claimPaidAmount;
              this.ProfessionClaimList.balanceDue =
                this.ProfessionClaimList.totalcharges -
                this.ProfessionClaimList.amountPaid;
            });
        },
       
      );
  }
  //................................................ KeyPress................................................
  keyPress(event: any) {
    const pattern = /[0-9]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }
  //................................................ PhoneFormat................................................
  PhoneFormat() {
    this.ProfessionClaimList.subscriberPhone = this.general.converPhoneGoogleLib(
      this.ProfessionClaimList.subscriberPhone
    );
  }
  //...................................UpdateProfessionalClaim...............................................................
  updateProfessionalClaim(status) {
    console.log(this.ProfessionClaimList.resubmissionLid,"this.ProfessionClaimList.resubmissionLid")
    var ResubmissionValue = this.ResubmissionList.filter(
      (fg) => fg.id == this.ProfessionClaimList.resubmissionLid
    )[0].lovName;
    if (ResubmissionValue == "VOID" || ResubmissionValue == "REPLACEMENT") {
      let payerClaimControl =
        this.ProfessionClaimList.payerClaimControl == null ||
          this.ProfessionClaimList.payerClaimControl == undefined ||
          this.ProfessionClaimList.payerClaimControl == ""
          ? null
          : this.ProfessionClaimList.payerClaimControl;
      if (payerClaimControl == null) {
        this.toastrService.error("Payer Claim Control Mandatory");
        return;
      }
    }
    var tempDOBDate = this.TemppClientList.subscriberDOB + "Z";
    var temadmissiondate =
      this.ProfessionClaimList.admissionDate != null
        ? this.ProfessionClaimList + "Z"
        : null;
    this.ProfessionClaimList.subscriberDOB =
      this.UserConfirmDOBDate == 1
        ? new Date(
          new Date(
            this.ProfessionClaimList.subscriberDOB
          ).toLocaleDateString() +
          " " +
          new Date().toLocaleTimeString()
        )
        : new Date(tempDOBDate);
    this.ProfessionClaimList.admissionDate =
      this.AdmissionDatecheck == 1
        ? new Date(
          new Date(
            this.ProfessionClaimList.admissionDate
          ).toLocaleDateString() +
          " " +
          new Date().toLocaleTimeString()
        )
        : new Date(temadmissiondate);
    this.ProfessionClaimList.resubmissionLid = 
      this.ProfessionClaimList.resubmissionLid
    this.ProfessionClaimList.claimMasterStatusLid=(this.ProfessionClaimList.claimMasterStatusLid!=null &&
    this.ProfessionClaimList.claimMasterStatusLid!=undefined && this.ProfessionClaimList.claimMasterStatusLid!='')?
    this.ProfessionClaimList.claimMasterStatusLid:this.ProfessionClaimList.claimMasterStatusLid


    var saveList: Proclaim = JSON.parse(
      JSON.stringify(this.ProfessionClaimList)
    );
    let url = "api/ClaimMaster/EditClaim";
    this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(saveList, url)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (data: number) => {
          this.toastrService.success("Claim details updated successfully!");
          setTimeout(() => {
            this.toastrService.clear();
          }, 8000);
          this.Profession = false;
          this.timesheetIdlist = [];
          this.timesheetdateList = [];
          this.update = false;
          // need to emit
          this.BacktoClaimsList();
          this.UserConfirmDOBDate = 0;
        },
      
      );
  }
  // ................................................decimalOnly................................................
  decimalOnly(event) {
    if (!(this.global.isdigit(event.key) || event.key == ".")) {
      event.preventDefault();
    }
    
  }
  //........................... paidChange................................................
  paidChange(event: IMyInputFieldChanged, pc) {
    let value = event.value;
    if (value.length == 5 && value.substring(2, 3) != "/") {
      pc.paidDateFormated =
        value.substring(0, 2) +
        "/" +
        value.substring(2, 4) +
        "/" +
        value.substring(4, 10);
    }
  }
  //.......................onPaiddatechanged...................................................
  onPaiddatechanged(event: IMyDateModel, pc) {
    pc.paidDateFormated = event.formatted;
  }
  // ...............................updatePaidAmount...............................
  updatePaidAmount() {
    this.claimServiceLines.forEach((element) => {
      element.paidDate =
        element.paidDateFormated != null && element.paidDateFormated != ""
          ? this.global.getDateTimeString(element.paidDateFormated)
          : null;
      element.payerPaid =
        element.payerPaid == null || element.payerPaid == ""
          ? null
          : parseFloat(element.payerPaid);

      element.spendownCharge =
        element.spendownCharge == undefined ||
          element.spendownCharge == 0 ||
          element.spendownCharge == null ||
          element.spendownCharge == ""
          ? null
          : parseFloat(element.spendownCharge);
          element.overBilledAmount =
          element.overBilledAmount == undefined ||
            element.overBilledAmount == 0 ||
            element.overBilledAmount == null ||
            element.overBilledAmount == ""
            ? null
            : parseFloat(element.overBilledAmount);
      });
  
    if (this.isManuallyPost == false) {
      let urlcsl = "api/ClaimProcess/updatePaidAmount";
      this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(this.claimServiceLines,urlcsl)
        .pipe(takeUntil(this.onDestroy$))
        .subscribe(
          (data) => {
            this.toastrService.success("Paid Amount updated successfully!");
            setTimeout(() => {
              this.toastrService.clear();
            }, 5000);
            let params = new URLSearchParams();
            params.append(
              "ClaimMasterId",
              this.isInputOptions.claimMasterId.toString()
            );
            let urlLD = "api/ClaimMaster/getServiceLineDetails?";
            this.CommonAPI.GetFunctionwithResponseTypeJson(params, urlLD)
              .pipe(takeUntil(this.onDestroy$))
              .subscribe((data: ClaimServiceLine[]) => {
                this.ProfessionClaimList.serviceDetailsList = data;
              });
            let param = new URLSearchParams();
            param.append(
              "ClaimMasterId",
              this.isInputOptions.claimMasterId.toString()
            );
            let urlAD = "api/ClaimMaster/GetClaimAmount?";
            this.CommonAPI.GetFunctionwithResponseTypeJson(param, urlAD)
              .pipe(takeUntil(this.onDestroy$))
              .subscribe((data: AmountInfo) => {
                this.ProfessionClaimList.totalcharges = data.claimTotalcharges;
                this.ProfessionClaimList.amountPaid = data.claimPaidAmount;
                this.ProfessionClaimList.balanceDue =
                  this.ProfessionClaimList.totalcharges -
                  this.ProfessionClaimList.amountPaid;
              });
            document.getElementById("paidAmountUpdateSModalSpan").click();
          },
          (err: any) => {
            this.toastrService.error(err, "Error");
          }
        );
    } else if (this.isManuallyPost == true) {
      let url = "api/ClaimProcess/ManuallyPostPayment";
      this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(this.claimServiceLines,url)
        .pipe(takeUntil(this.onDestroy$))
        .subscribe(
          (data) => {
            this.toastrService.success("Paid Amount updated successfully!");
            setTimeout(() => {
              this.toastrService.clear();
            }, 5000);
            document.getElementById("paidAmountUpdateSModalSpan").click();
            this.EnableProfesionClaim();
          },
          (err: any) => {
            this.toastrService.error(err, "Error");
          }
        );
    }
  }
  // ...............................BacktoClaimsList..............................................................
  BacktoClaimsList() {
    this.global.isCheckOperationDashboardRecord = false;
    this.isOutputOptions.emit({
      isedited: false,
      claimMasterId: this.isInputOptions.claimMasterId,
      tabsChanges: this.isInputOptions.tabsChanges,
      is87IClaim: this.isInputOptions.is87IClaim,
      ClaimsfilterDetails: this.isInputOptions.ClaimsfilterDetails,
      isClaimsViewEnable: true,
      ReadyColumns: this.isInputOptions.ReadyColumns,
      claimsStatusData: this.isInputOptions.claimsStatusData,
      ActiveColumns: this.isInputOptions.ActiveColumns,
      ArchiveColumns: this.isInputOptions.ArchiveColumns,
      groupIds: this.isInputOptions.groupIds,
      PayorIds: this.isInputOptions.PayorIds,
      masterServiceIds: this.isInputOptions.masterServiceIds,
      selectedGroupName: this.isInputOptions.selectedGroupName,
      companyIds: this.isInputOptions.companyIds,
      isClaimAttachment :false
    });
  }
  //............................... checkboxFunction..............................................................
  checkboxFunction() {
    this.showEditorView = false;
  }
  // ...............................Admissiondatechange..............................................................
  Admissiondatechange(event: IMyInputFieldChanged) {
    this.AdmissionDatecheck = 1;
    let value = event.value;
    if (value.length == 5 && value.substring(2, 3) != "/") {
      this.ProfessionClaimList.admissionDate =
        value.substring(0, 2) +
        "/" +
        value.substring(2, 4) +
        "/" +
        value.substring(4, 10);
    }
  }
  //.......................................................... DOBdatechange...............................
  DOBdatechange(event: IMyInputFieldChanged) {
    this.UserConfirmDOBDate = 1;
    let value = event.value;
    if (value.length == 5 && value.substring(2, 3) != "/") {
      this.ProfessionClaimList.subscriberDOB =
        value.substring(0, 2) +
        "/" +
        value.substring(2, 4) +
        "/" +
        value.substring(4, 10);
    }
  }
  // ..........................................................onDateChanged..........................................................
  onDateChanged(event: IMyDateModel) {
    this.UserConfirmDOBDate = 1;
    this.ProfessionClaimList.subscriberDOB = event.formatted;
  }
  //.............................. onAdmissionDateChanged............................................................
  onAdmissionDateChanged(event: IMyDateModel) {
    this.AdmissionDatecheck = 1;
    this.ProfessionClaimList.admissionDate = event.formatted;
  }
  //............................. getzipcodeSUbscriber.................................................................
  getzipcodeSUbscriber() {
    let myParams1 = new URLSearchParams();
    myParams1.append("Street", this.ProfessionClaimList.subscriberAddressLine1);
    myParams1.append("City", this.ProfessionClaimList.subscriberCity);
    myParams1.append("State", this.ProfessionClaimList.subscriberState);
    let url = "api/Client/getZipcode?"
    this.CommonAPI.GetFunctionwithResponseTypeJson(myParams1,url)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (data: ZipcodeDetail) => {
          this.ProfessionClaimList.subscriberZIPCode = data.zipcode;
        },
       
      );
  }
  //...............................getzipcodeBilling.....................................................................
  getzipcodeBilling() {
    let myParams1 = new URLSearchParams();
    myParams1.append("Street", this.ProfessionClaimList.billingAddressLine1);
    myParams1.append("City", this.ProfessionClaimList.billingCity);
    myParams1.append("State", this.ProfessionClaimList.billingState);
    this.global.loading = true;
    let url = "api/Client/getZipcode?"
    this.CommonAPI.GetFunctionwithResponseTypeJson(myParams1,url)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (data: ZipcodeDetail) => {
          this.global.loading = false;
          this.ProfessionClaimList.billingZIPCode = data.zipcode;
        },
      
      );
  }
  //..................................................refreshToGetDropDownValues.......................................
  refreshToGetDropDownValues(ListCode: string) {
    let url = "api/LOV/getLovDropDown?"
    let params = new URLSearchParams();
    params.append("ListCode", ListCode);
    if (this.isInputOptions.claimMasterId != "00000000-0000-0000-0000-000000000000") {
      this.CommonAPI.RefreshDropDownList(ListCode,params, url, "LovDropDown").then((data: any) => {
        if (ListCode == "GENDER") {
          this.genderList = data?.filter(ele=>ele.lovCode?.toUpperCase()!='OTHERS');
        }
        if (ListCode == "RESUBMISSION") {
          this.ResubmissionList = data;
        }
        if (ListCode == "ALTERCLAIMSTATUS") {
          this.AlterClaimsStatus = data;
        }
      });
    }
  }
  //.......................................... getGender................................................................
  getGender() {
    let url = "api/LOV/getLovDropDown?";
    let params = new URLSearchParams();
    params.append("ListCode", 'GENDER');
    this.CommonAPI.getDropDownList("GENDER",params, url, "LovDropDown").then(
      (data: any) => {
        this.genderList = data?.filter(ele=>ele.lovCode?.toUpperCase()!='OTHERS');
      },
      (err) => { }
    );
  }
  //..................................................MarkServicePaid.......................................
  MarkServicePaid() {
    this.MarkServiceAsPaid.paidAmount = 0
    this.MarkServiceAsPaid.claimMasterIds.push(this.isInputOptions.claimMasterId)
    this.MarkServiceAsPaid.paidDate = (this.Markaspaidlist.paidDate != null) ? this.global.getDateTimeString(this.Markaspaidlist.paidDate) : null
    this.MarkServiceAsPaid.typeofpay = this.Markaspaidlist.typeofPay;
    let url = "api/ClaimMaster/MarkAsPaid";
    this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(this.MarkServiceAsPaid,url)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (data: any) => {
          this.toastrService.success("Payment details updated successfully!");
          setTimeout(() => {
            this.toastrService.clear();
          }, 8000);
          let params = new URLSearchParams();
          params.append(
            "ClaimMasterId",
            this.isInputOptions.claimMasterId.toString()
          );
          let urlLD = "api/ClaimMaster/getServiceLineDetails?";
          this.CommonAPI.GetFunctionwithResponseTypeJson(params, urlLD)
            .pipe(takeUntil(this.onDestroy$))
            .subscribe((data: ClaimServiceLine[]) => {
              this.ProfessionClaimList.serviceDetailsList = data;
            });
          let param = new URLSearchParams();
          param.append(
            "ClaimMasterId",
            this.isInputOptions.claimMasterId.toString()
          );

          let urlAD = "api/ClaimMaster/GetClaimAmount?";
          this.CommonAPI.GetFunctionwithResponseTypeJson(param, urlAD)
            .pipe(takeUntil(this.onDestroy$))
            .subscribe((data: AmountInfo) => {
              this.ProfessionClaimList.totalcharges = data.claimTotalcharges;
              this.ProfessionClaimList.amountPaid = data.claimPaidAmount;
              this.ProfessionClaimList.balanceDue =
                this.ProfessionClaimList.totalcharges -
                this.ProfessionClaimList.amountPaid;
            });
          document.getElementById("openMarkPaidModal").click();
        },
        (err: any) => {
          let val: any = err;
          this.toastrService.error(val, "Error");
          document.getElementById("openMarkPaidModal").click();
        }
      );
  }
  //..................... Timesheet Verification..................................................................
  fromtimesheetverification(claimid) {
    this.openverification = false;
    document.getElementById("openupdatetimesheet").click();
    this.EnableProfesionClaim();
  }
  //...............................................Update Timesheet................................................
  updatetimesheet() {
    if (this.ProfessionClaimList.serviceDetailsList.length > 0) {
      if (this.timesheetIdlist.length == 0) {
        this.timesheetIdlist = this.ProfessionClaimList.timesheetIdandDates.map(
          (p) => p.timesheetId
        );
      }
      if (this.timesheetdateList.length == 0) {
        this.timesheetdateList =
          this.ProfessionClaimList.timesheetIdandDates.map(
            (p) => p.timesheetDate
          );
      }
      this.timesheetVerificationInput.ids = this.timesheetIdlist;
      this.timesheetVerificationInput.claimId =
        this.ProfessionClaimList.masterClaimId;
      this.timesheetVerificationInput.start = this.timesheetdateList[0];
      this.timesheetVerificationInput.end =
        this.timesheetdateList[this.timesheetdateList.length - 1];
      this.timesheetVerificationInput.from = "Claim";
      document.getElementById("openupdatetimesheet").click();
      this.openverification = true;
    }
  }
  //..................................Save Timesheet..................................................................
  savetimesheet() {
    if (
      this.totalhours != 0 &&
      this.totalhours != null &&
      this.totalhours != undefined &&
      this.totalhours != ""
    ) {
      this.timesheetserviceLine.totalhours = parseFloat(this.totalhours);
    } else {
      this.timesheetserviceLine.totalhours = 0;
    }
    this.timesheetserviceLine.claimmasterId =
      this.ProfessionClaimList.masterClaimId;

    this.timesheetserviceLine.serviceDate = this.timesheetserviceDate;
    this.timesheetserviceLine.serviceDate = new Date(
      new Date(this.timesheetserviceLine.serviceDate).toDateString() +
      " " +
      "00:00:00" +
      " " +
      "GMT"
    )
      .toISOString()
      .replace("Z", "");
      let url = "api/ClaimMaster/AddTimsheettoServiceLine";
    this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(this.timesheetserviceLine,url)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (data) => {
          this.timesheetdateList.push(this.timesheetserviceLine.serviceDate);
          this.timesheetIdlist.push(data);
          this.timesheetdateList = this.timesheetdateList.sort(
            (a, b) => new Date(a).getTime() - new Date(b).getTime()
          );
          document.getElementById("opencreatetimesheet").click();
          document.getElementById("openupdatetimesheet").click();
          this.updatetimesheet();
        },
        (err: any) => {
          this.timesheetserviceLine.serviceDate = this.datePipe.transform(
            this.timesheetserviceLine.serviceDate,
            "MM/dd/yyyy"
          );
          this.timesheetserviceDate = this.timesheetserviceLine.serviceDate;
          this.toastrService.error(err);
          setTimeout(() => {
            this.toastrService.clear();
          }, 8000);
        }
      );
  }
  //..................................MarkPaiddatechange.........................................................
  MarkPaiddatechange(event: IMyInputFieldChanged) {
    let value = event.value;
    if (value.length == 5 && value.substring(2, 3) != "/") {
      this.Markaspaidlist.paidDate =
        value.substring(0, 2) +
        "/" +
        value.substring(2, 4) +
        "/" +
        value.substring(4, 10);
    }
  }
  //..................................MakeMarkServicePaid.........................................................
  MakeMarkServicePaid() {
    this.Markaspaidlist = new PaymentInfo();
    this.Markaspaidlist.paidDate = (new Date().getMonth() + 1) + '/' + new Date().getDate() + '/' + new Date().getFullYear();

  }
  //..................................onMarkPaidDateChanged.........................................................
  onMarkPaidDateChanged(event: IMyDateModel) {
    this.Markaspaidlist.paidDate = event.formatted;
  }
  //.....................................numberonly....................................................................
  numberonly(event: any) {
    this.ref.detach();
    setInterval(() => {
      this.ref.detectChanges();
    }, 10);
    if (
      ((event.which < 48 &&
        event.which != 8 &&
        event.which != 46 &&
        event.which != 39 &&
        event.which != 37) ||
        event.which > 57) &&
      ((event.which < 96 &&
        event.which != 8 &&
        event.which != 46 &&
        event.which != 39 &&
        event.which != 37) ||
        event.which > 105)
    ) {
      event.preventDefault();
    }
    let txt = "";

    txt = this.totalhours;
    txt = txt.trim ? txt.trim() : txt.replace(/^\s+/, "");
    if (txt.length == 1) {
      if (txt == "2") {
        if (event.key > 3) {
          event.preventDefault();
        }
      }
      if (parseInt(txt) > 2) {
        if (event.which != 46) {
          event.preventDefault();
        }
      }
      if (txt == ".") {
        if (
          !(
            event.which == 50 ||
            event.which == 53 ||
            event.which == 55 ||
            event.which == 48
          )
        ) {
          event.preventDefault();
        }
      }
    }
    if (txt.length == 2) {
      let tempdata = txt.split("");
      if (!(tempdata[1] == ".")) {
        if (tempdata[0] == ".") {
          if (tempdata[1] == "5" || tempdata[1] == "0") {
            if (!(event.which == 48)) {
              event.preventDefault();
            }
          }
          if (tempdata[1] == "2" || tempdata[1] == "7") {
            if (!(event.which == 53)) {
              event.preventDefault();
            }
          }
        } else if (event.which != 46) {
          event.preventDefault();
        }
      } else {
        if (
          !(
            event.which == 50 ||
            event.which == 53 ||
            event.which == 55 ||
            event.which == 48
          )
        ) {
          event.preventDefault();
        }
      }
    }
    if (txt.length == 3) {
      let tempdata = txt.split("");
      if (tempdata[0] == ".") {
        event.preventDefault();
      }
      if (tempdata[2] == ".") {
        if (
          !(
            event.which == 50 ||
            event.which == 53 ||
            event.which == 55 ||
            event.which == 48
          )
        ) {
          event.preventDefault();
        }
      }
      if (tempdata[1] == ".") {
        let tempdata1 = txt.split(".");
        if (tempdata1[1] == "5" || tempdata1[1] == "0") {
          if (!(event.which == 48)) {
            event.preventDefault();
          }
        }
        if (tempdata1[1] == "2" || tempdata1[1] == "7") {
          if (!(event.which == 53)) {
            event.preventDefault();
          }
        }
      }
    }
    if (txt.length == 4) {
      let tempdata = txt.split(".");
      if (tempdata[1].length == 2) {
        event.preventDefault();
      }
      if (tempdata[1] == "5" || tempdata[1] == "0") {
        if (!(event.which == 48)) {
          event.preventDefault();
        }
      }
      if (tempdata[1] == "2" || tempdata[1] == "7") {
        if (!(event.which == 53)) {
          event.preventDefault();
        }
      }
    }
    let val = txt.split(".");
    if (txt.length > 4) {
      event.preventDefault();
    }
  }
  //.....................................servicedatechange....................................................................
  servicedatechange(event: IMyInputFieldChanged) {
    let value = event.value;
    if (value.length == 5 && value.substring(2, 3) != "/") {
      this.timesheetserviceLine.serviceDate =
        value.substring(0, 2) +
        "/" +
        value.substring(2, 4) +
        "/" +
        value.substring(4, 10);
      this.timesheetserviceDate =
        value.substring(0, 2) +
        "/" +
        value.substring(2, 4) +
        "/" +
        value.substring(4, 10);
    }
  }
  //.....................................serviceDateChanged....................................................................
  serviceDateChanged(event: IMyDateModel) {
    this.timesheetserviceLine.serviceDate = event.formatted;
    this.timesheetserviceDate = event.formatted;
  }
  //.....................................SpendPaiddatechange....................................................................
  SpendPaiddatechange(event: IMyInputFieldChanged) {
    let value = event.value;
    if (value.length == 5 && value.substring(2, 3) != "/") {
      this.spendDownDetails.formatedPaidDate =
        value.substring(0, 2) +
        "/" +
        value.substring(2, 4) +
        "/" +
        value.substring(4, 10);
    }
  }
  //.....................................onSpendPaiddatechanged....................................................................
  onSpendPaiddatechanged(event: IMyDateModel) {
    this.spendDownDetails.formatedPaidDate = event.formatted;
  }
  //.....................................closeUpdateTimesheet....................................................................
  closeUpdateTimesheet() {
    if (this.timesheetVerificationInput.errorValidation == true) {
      this.toastrService.error(
        "Please select and update the claim if timesheet is modified!"
      );
      return;
    } else {
      this.openverification = false;
      document.getElementById("openupdatetimesheet").click();
    }
  }
  //.....................................showClaimHistory....................................................................
  showClaimHistory() {
    let params = new URLSearchParams();
    params.append("ClaimMasterId", this.isInputOptions.claimMasterId.toString());
    let url = "api/ClaimMaster/GetClimeHistory?";
    this.CommonAPI.GetFunctionwithResponseTypeJson(params,url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.claimHistoryData = data;
      this.claimHistoryData.reprocessedDate = this.claimHistoryData.forEach(ele => {
        ele.reprocessedDate = (ele.reprocessedDate == "0001-01-01T00:00:00") ? null : ele.reprocessedDate;
      })
    },
      (err: any) => {
        this.toastrService.error(err);
        setTimeout(() => {
          this.toastrService.clear();
        }, 8000)
      })

  }
  //.....................................getseparateClaimDetails....................................................................  //.....................................serviceDateChanged....................................................................
  getseparateClaimDetails(data) {
    let params = new URLSearchParams();
    params.append("Claim_835Id", data.id.toString());
    let url = "api/Import/GetInvoice835?";
    this.CommonAPI.GetFunctionwithResponseTypeJson(params,url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.View835Claim = data;
      this.isEemptyImportClaim = (this.View835Claim.length == 0 ? true : false);
      document.getElementById("openViewClaimHistory").click();
      this.View835Claim[0]?.transaction835s.forEach(element => {
        this.companydetails = element.companydetails
        this.payorDetail = element.payorDetail
        this.paymentDetail = element.paymentDetail
        this.patientClaimDetails = element.patient_ClaimDetails
        element.patient_ClaimDetails.forEach(element1 => {
          this.TotalUnits = this.TotalUnits + element1.totalUnit;
        });
      });
    },
      (err: any) => {
        this.toastrService.error(err);
        setTimeout(() => {
          this.toastrService.clear();
        }, 8000)
      })
  }
  //.....................................kendopdfdownloadList....................................................................
  kendopdfdownloadList() {
    this.pdflist.A4 = true,
      this.pdflist.portrait = true,
      this.pdflist.keepTogether = ".prevent-split",
      this.pdflist.scale = 0.8,
      this.pdflist.margin = { left: "0.6cm", top: "0.4cm", right: "0.6cm", bottom: "3cm" }
    this.pdflist.saveAs("837Report" + new Date().toLocaleDateString() + '-' + new Date().toLocaleTimeString());
  }

  validateNumber(event: any) {
    event.target.value = event.target.value.replace(/[^a-zA-Z0-9]/g, '');
  }

// get Status Lov ReportType
getStatusLovReportType() {
  let url = "api/LOV/getLovDropDown?"
  let params = new URLSearchParams();
  params.append("ListCode", 'ATTACHMENTREPORTTYPE ');
  this.CommonAPI.getDropDownList('ATTACHMENTREPORTTYPE', params, url, "LovDropDown").then((data: any[]) => {
    this.getReportTypeList = data;
  },(err: any) => {
    this.toastrService.error(err, "Error");
    setTimeout(() => {
      this.toastrService.clear()
    }, 6000);
  })
}

//  get Status Lov TXN
getStatusLovTXN() {
  let url = "api/LOV/getLovDropDown?"
  let params = new URLSearchParams();
  params.append("ListCode", 'REPORTTRANSMISSION(TX)');
  this.CommonAPI.getDropDownList('REPORTTRANSMISSION(TX)', params, url, "LovDropDown").then((data: any[]) => {
    this.getTXNList = data;
  }, (err: any) => {
    this.toastrService.error(err, "Error");
    setTimeout(() => {
      this.toastrService.clear()
    }, 6000);
  })
}
  // get Claim Attachment Details
  getClaimAttachmentDetails(){
    let url ="api/ClaimMaster/GetAUCCoversheet"
    this.claimAttachmentIds.push(this.isInputOptions.claimMasterId);
    this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(this.claimAttachmentIds,url).pipe(takeUntil(this.onDestroy$)).subscribe((data:any)=>{
     this.global.coverLetterDetails=data[0];
     setTimeout(() => {
      this.isViewUACCoverLetter=true;
       document.getElementById('AppealRequestFormModalOpen').click();
     }, 500);     
    },
   (err:any)=>{
       this.toastrService.error(err,'Error')
       setTimeout(() => {
         this.toastrService.clear();
       }, 6000);
   })
}

  //......................................Get ReportTransmissionList.....................................
  getReportTransmissionList() {
    let url = "api/LOV/LovDropDownWithCode?"
    let params = new URLSearchParams();
    params.append("ListCode", "REPORTTRANSMISSION(TX)CODE");
    this.CommonAPI.getDropDownList("REPORTTRANSMISSION(TX)CODE", params, url, "LovDropDown").then(
      (data: any) => {
        this.reportTransmissionList = data;        
      },
      (err: any) => {
        this.toastrService.error(err);
      }
    );
  }
//......................................Get ReportTypeDeopdownList.....................................
  getReportTypeDeopdownList() {
    let url = "api/LOV/LovDropDownWithCode?"
    let params = new URLSearchParams();
    params.append("ListCode", "PWK01ATTACHMENTREPORT");
    this.CommonAPI.getDropDownList("PWK01ATTACHMENTREPORT", params, url, "LovDropDown").then(
      (data: any) => {
        this.reportTypeDeopdownList = data;        
      },
      (err: any) => {
          this.toastrService.error(err);
      }
    );
  }
  show() {
    if(this.ProfessionClaimList.serviceDetailsList?.length<10){
      this.gridservicLine.columnChooserModule.openColumnChooser(500, -250);
    }
    else{
      this.gridservicLine.columnChooserModule.openColumnChooser(500, 50);
    }
    }
  //.....................................ngOnDestroy....................................................................
  public ngOnDestroy(): void {
    this.onDestroy$.next();
  }
}

